import {styled} from '@mui/material/styles';
import {ToggleButton} from '@mui/material';
import LEGACY_COLORS from '@/styles/legacyColors';

const SocialNetworksToggleButton = styled(ToggleButton)`
  &.MuiButtonBase-root {
    &.MuiToggleButton-root {
      &.MuiToggleButton-sizeMedium {
        &.MuiToggleButton-standard {
          min-width: 46px;
          height: 36px;
          color: ${LEGACY_COLORS.GRAY};
          border: 1px solid ${LEGACY_COLORS.GRAY_LIGHT};
          border-radius: 5px;
          font-size: 16px;
          font-weight: 400;
          padding: 10px;
          text-transform: none;
          line-height: 23px;
          margin-top: 0;
          margin-left: 0;
          box-sizing: border-box;

          &.Mui-selected {
            background-color: ${LEGACY_COLORS.GRAY_LIGHTER};
            border: 2px solid ${LEGACY_COLORS.GRAY};
            box-sizing: border-box;
          }
        }
      }
    }
  }
`;

export default SocialNetworksToggleButton;
